"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Radiobox_1 = require("./Radiobox");
Object.defineProperty(exports, "Radiobox", { enumerable: true, get: function () { return Radiobox_1.Radiobox; } });
//# sourceMappingURL=index.js.map